"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUrlProperty = exports.urlPropertyDefinition = void 0;
exports.urlPropertyDefinition = {
    view: {
        label: 'URL',
        style: 'url',
        hint: 'Where a user is taken to; paste full redbull.com URL of an older asset if it should re-use the same URL (e.g. to group event pages); or an external URL for externally hosted sites.',
    },
    constraints: [
        {
            name: 'pattern',
            argument: '^https?:\\/\\/(?:\\S+(?::\\S*)?@)?(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))\\.?)(?::\\d{2,5})?(?:[/?#]\\S*)?$',
        },
    ],
    type: 'text',
    multiple: false,
    name: 'url',
};
const isUrlProperty = (prop) => {
    return prop.name === exports.urlPropertyDefinition.name;
};
exports.isUrlProperty = isUrlProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXJsLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvdXJsLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEscUJBQXFCLEdBQUc7SUFDbkMsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLEtBQUs7UUFDWixLQUFLLEVBQUUsS0FBSztRQUNaLElBQUksRUFBRSxzTEFBc0w7S0FDN0w7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxTQUFTO1lBQ2YsUUFBUSxFQUFFLGtlQUFrZTtTQUM3ZTtLQUNGO0lBQ0QsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxLQUFLO0NBQ29CLENBQUE7QUFJMUIsTUFBTSxhQUFhLEdBQUcsQ0FBQyxJQUFrQixFQUF1QixFQUFFO0lBQ3ZFLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyw2QkFBcUIsQ0FBQyxJQUFJLENBQUE7QUFDakQsQ0FBQyxDQUFBO0FBRlksUUFBQSxhQUFhLGlCQUV6QiJ9